module.exports = __webpack_public_path__ + "img/position_click.ae4ac7e6.svg";